export default __webpack_public_path__ + "static/media/nurse_call_system.f1aa3a1c.png";